import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { initLogos }  from './logo.js';
import { initFooter } from './footer.js';
import { initBlogTypewriter } from './blog-typewriter.js';

import '../css/app.css';

gsap.registerPlugin(ScrollTrigger);
// Vite's esbuild pre-bundler renames ScrollTrigger's class name (to something
// like "ScrollTrigger3") while merging gsap + gsap/ScrollTrigger deps, which
// stops gsap.timeline({ scrollTrigger: {...} }) from finding the plugin via
// _globals.ScrollTrigger. Registering it manually under the canonical name
// restores the lookup.
gsap.core.globals('ScrollTrigger', ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {
    const navToggle = document.getElementById('nav-toggle');
    const navLinks  = document.getElementById('nav-links');
    if (navToggle && navLinks) {
        navToggle.addEventListener('click', () => {
            const open = navLinks.classList.toggle('is-open');
            navToggle.classList.toggle('is-open', open);
            navToggle.setAttribute('aria-expanded', String(open));
        });
        navLinks.querySelectorAll('a').forEach(a =>
            a.addEventListener('click', () => {
                navLinks.classList.remove('is-open');
                navToggle.classList.remove('is-open');
                navToggle.setAttribute('aria-expanded', 'false');
            })
        );
    }

    initLogos();
    initFooter();
    initBlogTypewriter();
});
